import type { FC } from 'react';
import React from 'react';

import type { LoaderProps } from '../Loader';
import Loader from '../Loader';
import styles from './PlaceholderLoader.scss';

type PlaceholderLoaderProps = {
  sectionHeight: string;
  loaderSize?: LoaderProps['size'];
};

export const PlaceholderLoader: FC<PlaceholderLoaderProps> = ({
  sectionHeight,
  loaderSize,
}) => {
  return (
    <div className={styles.root} style={{ height: sectionHeight }}>
      <Loader className={styles.loader} size={loaderSize} />
    </div>
  );
};
